import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import styled from 'styled-components';

const { Text, Button } = Common;

const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60vh;
`;

const Img = styled(Image)`
  margin-bottom: 32px;
`;

const ContentWrapper = styled.div`
  text-align: center;

  ${Text} {
    text-align: center;
  }
`;

const ButtonDiscover = styled(Button).attrs({
  type: 'primary',
})`
  font-size: 16px;
  height: 44px;
  margin: auto;
  width: 200px;

  :hover {
    // TODO: Add Color to @stockbit/ui
    background: #3a3a3a;
    border-color: #3a3a3a;
  }
`;

export { EmptyStateWrapper, Img, ContentWrapper, ButtonDiscover };
